export default function (route, repalce) {
  return route.replace(/{{.*}}/, repalce);
}



// WEBPACK FOOTER //
// ./src/helpers/replaceRouteVar.js